import React from "react";

const Banner = ({ careerData }) => {
  console.log(careerData); // Debug
  console.log(careerData.tageline); // Debug
  return (
    <div className="relative w-full h-[500px] lg:h-[700px]">
      {/* Desktop Banner */}
      <div
        className="hidden lg:block absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${careerData.image})` }}
      />
      {/* Mobile Banner */}
      <div
        className="lg:hidden absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${careerData.image})` }}
      />
      {/* Text Overlay */}
      <div className="">
        <p className="w-full absolute inset-0 flex items-center justify-center text-white text-4xl sm:text-4xl md:text-[100px] font-bold z-10 px-4">
          {careerData.tageline}
        </p>
      </div>
    </div>
  );
};

export default Banner;
